import { render } from "./BellNotification.vue?vue&type=template&id=2031c077"
import script from "./BellNotification.vue?vue&type=script&lang=js"
export * from "./BellNotification.vue?vue&type=script&lang=js"

import "./BellNotification.vue?vue&type=style&index=0&id=2031c077&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__